module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-md"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n    Limite de 5MB e 2000 linhas por envio. Somente pátios aos quais você tem acesso podem ser alterados.\n  ")]), _vm._v(" "), (!_vm.arquivo) ? _c('div', {
    staticClass: "m-b"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.escolherArquivo
    }
  }, [_c('i', {
    staticClass: "fa fa-upload m-r-xs"
  }), _vm._v(" Selecionar planilha\n    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "inputArquivo",
    attrs: {
      "type": "file",
      "accept": ".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
    },
    on: {
      "change": _vm.onFileChange
    }
  })]) : _c('div', {
    staticClass: "m-b"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-file-excel-o m-r-xs"
  }), _vm._v(" " + _vm._s(_vm.arquivo.name))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs btn-link",
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.trocarArquivo
    }
  }, [_vm._v("\n      (trocar arquivo)\n    ")]), _vm._v(" "), (!_vm.resultado) ? _c('div', {
    staticClass: "m-t-sm"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.analisar
    }
  }, [_c('i', {
    staticClass: "fa fa-search m-r-xs"
  }), _vm._v(" Analisar planilha (pré-visualização)\n      ")])]) : _vm._e()]), _vm._v(" "), (_vm.resultado) ? _c('div', [_c('div', {
    staticClass: "alert",
    class: _vm.temResultadoAplicado ? 'alert-success' : 'alert-info'
  }, [_c('strong', [_vm._v(_vm._s(_vm.temResultadoAplicado ? 'Alterações aplicadas.' : 'Pré-visualização (nada foi gravado ainda).'))]), _vm._v(" "), _c('br'), _vm._v("\n      Total de linhas: " + _vm._s(_vm.resultado.totalLinhas) + " —\n      "), _c('span', {
    staticClass: "text-success"
  }, [_vm._v(_vm._s(_vm.resultado.totalAtualizadas) + " para atualizar")]), _vm._v(" —\n      "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.resultado.totalErros) + " com erro")])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "max-height": "45vh",
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-hover table-striped table-condensed b-t b-light"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.resultado.linhas), function(linha) {
    return _c('tr', {
      key: linha.linha
    }, [_c('td', [_vm._v(_vm._s(linha.linha))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(linha.numero))]), _vm._v(" "), _c('td', {
      class: _vm.corStatus(linha.status)
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.iconeStatus(linha.status)
    }), _vm._v(" " + _vm._s(linha.status) + "\n          ")]), _vm._v(" "), _c('td', [(linha.patioNovo) ? [_vm._v("\n              " + _vm._s(linha.patioAtual ? linha.patioAtual.nome : '-') + " → " + _vm._s(linha.patioNovo.nome) + "\n            ")] : [_vm._v("-")]], 2), _vm._v(" "), _c('td', [(linha.vagaNova) ? [_vm._v("\n              " + _vm._s(linha.vagaAtual || '-') + " → " + _vm._s(linha.vagaNova) + "\n            ")] : [_vm._v("-")]], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(linha.mensagem))])])
  }), 0)])]), _vm._v(" "), (_vm.temPreview) ? _c('div', {
    staticClass: "m-t"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": !_vm.podeConfirmar || _vm.loading
    },
    on: {
      "click": _vm.confirmar
    }
  }, [_c('i', {
    staticClass: "fa fa-check m-r-xs"
  }), _vm._v(" Confirmar e aplicar " + _vm._s(_vm.resultado.totalAtualizadas) + " alteração(ões)\n      ")]), _vm._v(" "), (!_vm.podeConfirmar) ? _c('span', {
    staticClass: "text-muted m-l-sm"
  }, [_vm._v("Nenhuma linha válida para aplicar.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.temResultadoAplicado) ? _c('div', {
    staticClass: "m-t"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Fechar")])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n    Envie uma planilha (.xlsx ou .xls) para atualizar o "), _c('strong', [_vm._v("pátio")]), _vm._v(" e/ou a "), _c('strong', [_vm._v("vaga")]), _vm._v(" de\n    várias GRVs de uma só vez. A planilha deve ter uma linha de cabeçalho com as colunas:\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "text-muted"
  }, [_c('li', [_c('strong', [_vm._v("numero")]), _vm._v(" (ou "), _c('strong', [_vm._v("GRV")]), _vm._v(") — obrigatória, número da GRV")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("patio")]), _vm._v(" — opcional, nome ou id do pátio de destino")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("vaga")]), _vm._v(" — opcional, nova vaga")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Linha")]), _vm._v(" "), _c('th', [_vm._v("GRV")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Pátio")]), _vm._v(" "), _c('th', [_vm._v("Vaga")]), _vm._v(" "), _c('th', [_vm._v("Mensagem")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d0e477a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/automacoes/components/AtualizarVagasEmMassa.vue
// module id = 1936
// module chunks = 18